<template>
  <NavbarApp/>
  <div class="data-privacy-container">
    <h2 class="data-privacy-title">
      {{ $t('termsAndConditionsPage.title') }}
    </h2>
    <ul class="data-privacy-list">
      <li id="section1">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section1.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section1.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section1.paragraph2') }}</p>
        <p>{{ $t('termsAndConditionsPage.section1.paragraph3') }}</p>
        <p>{{ $t('termsAndConditionsPage.section1.paragraph4') }}</p>
      </li>

      <li id="section2">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section2.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section2.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section2.paragraph2') }}</p>
      </li>

      <li id="section3">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section3.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section3.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section3.paragraph2') }}</p>
        <p>{{ $t('termsAndConditionsPage.section3.paragraph3') }}</p>
      </li>

      <li id="section4">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section4.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section4.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section4.paragraph2') }}</p>
        <p>{{ $t('termsAndConditionsPage.section4.paragraph3') }}</p>
        <p>{{ $t('termsAndConditionsPage.section4.paragraph4') }}</p>
      </li>

      <li id="section5">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section5.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section5.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section5.paragraph2') }}</p>
        <p>{{ $t('termsAndConditionsPage.section5.paragraph3') }}</p>
      </li>

      <li id="section6">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section6.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section6.paragraph1') }}</p>
        <p>{{ $t('termsAndConditionsPage.section6.paragraph2') }}</p>
      </li>

      <li id="section7">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section7.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section7.paragraph1') }}</p>
      </li>

      <li id="section8">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section8.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section8.paragraph1') }}</p>
      </li>

      <li id="section9">
        <h3 class="data-privacy-subtitle">
          {{ $t('termsAndConditionsPage.section9.title') }}
        </h3>
        <p>{{ $t('termsAndConditionsPage.section9.paragraph1') }}office@islaw.ro.</p>
        <p>{{ $t('termsAndConditionsPage.section9.paragraph2') }}</p>
      </li>
    </ul>
  </div>
  <Section4/>
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';

export default {
  name: 'TermsAndConditions',
  components: {
    NavbarApp,
    Section4
  }
};
</script>

<style scoped>
/* You can copy the styles from your DataPrivacy.vue or adapt them. */

/* --- Page Container and Layout --- */
.data-privacy-container {
  text-align: justify;
  text-justify: inter-word;
  max-width: 900px;
  margin: 40px auto;
  padding: 20px 20px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

/* --- Headings --- */
.data-privacy-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 1rem;
}

.data-privacy-subtitle {
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--primary-color);
  margin-top: 2rem;
  margin-bottom: 1rem;
}

/* --- Paragraphs and Lists --- */
p {
  margin-bottom: 1.5rem;
}

.data-privacy-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.data-privacy-list > li {
  margin-bottom: 2.5rem;
}

/* --- Responsive adjustments for smaller screens --- */
@media (max-width: 768px) {
  .data-privacy-container {
    margin: 20px;
    padding: 15px;
  }

  .data-privacy-title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  .data-privacy-subtitle {
    font-size: 1.3rem;
  }
}
</style>